import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {MapHeader} from "../../map/components/MapHeader";
import {ExpandablePanel} from "./atoms/ExpandablePanel";

interface IProps {
    isOpen: boolean;
    offersCount: number;
    propertiesCount: number | null;
    handleClose: () => void;
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
}

export const ExpandablePanelMapHeader = (props: IProps) => {
    const {offersCount, propertiesCount} = props;
    const pageTitle = useSelector((state: IRPStore) => state.metaData.standardMetaData.title);
    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);

    return (
        <ExpandablePanel isOpen={props.isOpen} handleClose={props.handleClose} className={expandableContentMapHeader}>
            <MapHeader
                pageTitle={pageTitle}
                offerCount={offersCount}
                propertiesCount={propertiesCount}
                selectedRegion={selectedRegion}
                generatedDescriptionAllowed={props.generatedDescriptionAllowed}
                onShowGeneratedDescription={props.onShowGeneratedDescription}
            />
        </ExpandablePanel>
    );
};

const expandableContentMapHeader = css({
    pt: 4,
    pb: 1,
    px: 3,
    border: "10px solid red",
    width: "100%",
    height: "auto",
    backgroundColor: "var(--colors-white)"
});
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {MapHeader} from "../../map/components/MapHeader";
import {ExpandablePanel} from "./atoms/ExpandablePanel";

interface IProps {
    isOpen: boolean;
    offersCount: number;
    propertiesCount: number | null;
    handleClose: () => void;
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
}

export const ExpandablePanelMapHeader = (props: IProps) => {
    const {offersCount, propertiesCount} = props;
    const pageTitle = useSelector((state: IRPStore) => state.metaData.standardMetaData.title);
    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);

    return (
        <ExpandablePanel isOpen={props.isOpen} handleClose={props.handleClose} className={expandableContentMapHeader}>
            <MapHeader
                pageTitle={pageTitle}
                offerCount={offersCount}
                propertiesCount={propertiesCount}
                selectedRegion={selectedRegion}
                generatedDescriptionAllowed={props.generatedDescriptionAllowed}
                onShowGeneratedDescription={props.onShowGeneratedDescription}
            />
        </ExpandablePanel>
    );
};

const expandableContentMapHeader = css({
    pt: 4,
    pb: 1,
    px: 3,
    border: "10px solid red",
    width: "100%",
    height: "auto",
    backgroundColor: "var(--colors-white)"
});
